import store from '../../store'

export default async (to, from, next) => {
	if (!store.getters.getLoggedInState) {
		next({ name: 'sign-in' })
	} else {
		next()
	}
}



// WEBPACK FOOTER //
// ./src/router/middleware/auth.js